
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import AuthSection from "./AuthSection";
import TestPaymentSection from "./TestPaymentSection";
import MontonioPaymentSection from "./MontonioPaymentSection";
import PaymentForm from "./PaymentForm";

interface CheckoutFormProps {
  user: any;
  courseId: string | null;
  authLoading: boolean;
  showAuthForm: boolean;
  onShowAuth: () => void;
  onAuthSuccess: () => void;
  courseData: any;
  userName: string;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const CheckoutForm = ({
  user,
  courseId,
  authLoading,
  showAuthForm,
  onShowAuth,
  onAuthSuccess,
  courseData,
  userName,
  loading,
  setLoading
}: CheckoutFormProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Maksmine</CardTitle>
        <CardDescription>Täida oma andmed, et ostuga jätkata</CardDescription>
      </CardHeader>
      <CardContent>
        <AuthSection 
          user={user} 
          showAuthForm={showAuthForm} 
          onShowAuth={onShowAuth} 
          onAuthSuccess={onAuthSuccess} 
        />
        
        {user && (
          <>
            {/* Test payment option for testing - hiding this per user request */}
            {/* <TestPaymentSection 
              courseId={courseId} 
              user={user} 
              authLoading={authLoading} 
              email={user?.email || ""}
              name={userName}
            /> */}
            
            {/* Montonio payment option */}
            <MontonioPaymentSection
              courseId={courseId}
              user={user}
              coursePrice={courseData?.price || 0}
              loading={loading}
              setLoading={setLoading}
              showTestModeAlert={false} // Hide test mode alert
            />
            
            {/* Payment form (if needed for other payment methods) */}
            <PaymentForm 
              coursePrice={courseData?.price || 0}
              loading={loading}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default CheckoutForm;
